import {
  EmployeeIdentityDocumentStatus,
  EmployeeRoleState,
  EmployeeRoleType,
} from '../../_interfaces/employee.interface';
import { FilterGroupType } from '../../shared/components/filter-button/filter-button.component';

export const employeeTableColumns = [
  {
    prop: 'first_name',
    name: 'First name',
    minWidth: 200,
    flexGrow: 1,
  },
  {
    prop: 'last_name',
    name: 'Last name',
    minWidth: 150,
    flexGrow: 1,
  },
  {
    prop: 'created',
    name: 'Date added',
    minWidth: 100,
    flexGrow: 1,
  },
  {
    prop: 'idnum_status',
    name: 'KYC Verification',
    sortable: false,
    minWidth: 100,
    flexGrow: 1,
  },
  {
    prop: 'actions',
    name: '',
    sortable: false,
    width: 100,
    resizeable: false,
    canAutoResize: false,
    cellClass: 'text-end',
  },
];

export const invitedEmployeeTableColumns = [
  {
    prop: 'first_name',
    name: 'First name',
    minWidth: 200,
    flexGrow: 1,
  },
  {
    prop: 'last_name',
    name: 'Last name',
    minWidth: 150,
    flexGrow: 1,
  },
  {
    prop: 'created',
    name: 'Date added',
    minWidth: 100,
    flexGrow: 1,
  },
  {
    prop: 'topup_frequency',
    name: 'Frequency',
    minWidth: 100,
    flexGrow: 1,
  },
  {
    prop: 'topup_amount',
    name: 'Target balance',
    minWidth: 100,
    flexGrow: 1,
  },
  {
    prop: 'actions',
    name: '',
    sortable: false,
    width: 100,
    resizeable: false,
    canAutoResize: false,
    cellClass: 'text-end',
  },
];

export interface EmployeeFilterParams {
  role: string;
  idnum_status: string;
}

export enum EmployeeFilterParamNames {
  role = 'role',
  idnum_status = 'idnum_status',
}

// Helper array for checking if any pending status is in the query
const pendingStatusArray = [
  EmployeeIdentityDocumentStatus.Rejected.toString(),
  EmployeeIdentityDocumentStatus.Error.toString(),
  EmployeeIdentityDocumentStatus.New.toString(),
  EmployeeIdentityDocumentStatus.None.toString(),
];

// the order here is important
const pendingStatusValue = pendingStatusArray.toString();

export function generateEmployeeFilterGroups(roleQuery: string[], statusQuery: string[]) {
  return [
    {
      filterLabel: 'User type',
      param: EmployeeFilterParamNames.role,
      type: FilterGroupType.radio,
      options: [
        {
          label: EmployeeRoleType.ADMIN,
          value: EmployeeRoleState.Admin,
          type: FilterGroupType.radio,
          name: EmployeeFilterParamNames.role,
          checked: roleQuery.includes(EmployeeRoleState.Admin.toString()),
        },
        {
          label: EmployeeRoleType.USER,
          value: EmployeeRoleState.User,
          type: FilterGroupType.radio,
          name: EmployeeFilterParamNames.role,
          checked: roleQuery.includes(EmployeeRoleState.User.toString()),
        },
      ],
    },
    {
      filterLabel: 'KYC Status',
      param: EmployeeFilterParamNames.idnum_status,
      type: FilterGroupType.radio,
      options: [
        {
          label: 'Done',
          value: EmployeeIdentityDocumentStatus.Verified,
          type: FilterGroupType.radio,
          name: EmployeeFilterParamNames.idnum_status,
          checked: statusQuery.includes(EmployeeIdentityDocumentStatus.Verified.toString()),
        },
        {
          label: 'Pending',
          value: pendingStatusValue,
          type: FilterGroupType.radio,
          name: EmployeeFilterParamNames.idnum_status,
          checked: pendingStatusArray.some((status) => statusQuery.includes(status)),
        },
      ],
    },
  ];
}

export { pendingStatusValue };
